import { render, staticRenderFns } from "./EezeeFooter.vue?vue&type=template&id=d4483642&scoped=true&"
import script from "./EezeeFooter.vue?vue&type=script&lang=js&"
export * from "./EezeeFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4483642",
  null
  
)

export default component.exports